"use strict";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useProvider } from "contexts/UniswapContext";
import { isDelegatedEOA } from "features/smartWallet/delegation/isDelegatedEOA";
import { ensure0xHex } from "utils/hex";
import { ReactQueryCacheKey } from "utilities/src/reactQuery/cache";
export function useIsSmartContractAddress(address, chainId) {
  const provider = useProvider(chainId);
  const getQueryOptions = useMemo(() => createGetQueryOptions({ provider }), [provider]);
  const { data, isLoading } = useQuery(getQueryOptions({ address, chainId }));
  return {
    isSmartContractAddress: data?.isSmartContractAddress ?? false,
    loading: isLoading
  };
}
const createGetQueryOptions = (ctx) => {
  return (input) => queryOptions({
    queryKey: [ReactQueryCacheKey.IsSmartContractAddress, input.address, input.chainId],
    queryFn: async () => {
      if (!input.address) {
        return null;
      }
      const result = await ctx.provider?.getCode(input.address);
      return result ?? null;
    },
    enabled: !!input.address,
    select: selectIsSmartContractAddress,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false
  });
};
function selectIsSmartContractAddress(bytecode) {
  if (!bytecode || bytecode === "0x") {
    return {
      isSmartContractAddress: false,
      isDelegatedAddress: false
    };
  }
  const result = isDelegatedEOA({ bytecode: ensure0xHex(bytecode) });
  return {
    isSmartContractAddress: !result.isDelegated,
    isDelegatedAddress: result.isDelegated
  };
}
